/**
 * Taken, CommonJS-ified, and heavily modified from:
 * https://github.com/flyingsparx/NodeDirectUploader
 */

S3Upload.prototype.signingUrl = "/sign-s3";
//S3Upload.prototype.fileElement = null;

S3Upload.prototype.onFinishS3Put = function(signResult) {
  return console.log("base.onFinishS3Put()", signResult.publicUrl);
};

S3Upload.prototype.onProgress = function(percent, status) {
  return console.log("base.onProgress()", percent, status);
};

S3Upload.prototype.onError = function(status) {
  return console.log("base.onError()", status);
};

function S3Upload(options) {
  if (options == null) {
    options = {};
  }
  for (option in options) {
    if (options.hasOwnProperty(option)) {
      this[option] = options[option];
    }
  }
}

S3Upload.prototype.createCORSRequest = function(method, url) {
  var xhr = new XMLHttpRequest();

  if (xhr.withCredentials != null) {
    xhr.open(method, url, true);
  }
  else if (typeof XDomainRequest !== "undefined") {
    xhr = new XDomainRequest();
    xhr.open(method, url);
  }
  else {
    xhr = null;
  }
  return xhr;
};

S3Upload.prototype.uploadToS3 = function(file, signResult) {
  // console.log("file ", file);
  var xhr = this.createCORSRequest("PUT", signResult);
  if (!xhr) {
    this.onError("CORS not supported");
  } else {
    xhr.onload = function() {
      if (xhr.status === 200) {
        this.onProgress(100, "Upload completed.");
        return this.onFinishS3Put(signResult);
      } else {
        console.log(xhr);
        return this.onError("Upload error: " + xhr.status);
      }
    }.bind(this);
    xhr.onerror = function() {
      return this.onError("XHR error.");
    }.bind(this);
    xhr.upload.onprogress = function(e) {
      var percentLoaded;
      if (e.lengthComputable) {
        percentLoaded = Math.round((e.loaded / e.total) * 100);

        if(file.uploadState == "aborted") { xhr.abort(); }
        return this.onProgress(percentLoaded, percentLoaded === 100 ? "Finalizing." : "Uploading.");
      }
    }.bind(this);
  }
  xhr.setRequestHeader("Content-Type", file.type);
  //xhr.setRequestHeader("x-amz-acl", "public-read");
  return xhr.send(file);
};

S3Upload.prototype.uploadFile = function(file) {
  //return this.executeOnSignedUrl(file, function(signResult) {
    return this.uploadToS3(file, this.signingUrl);
  //}.bind(this));
};


module.exports = S3Upload;


// WEBPACK FOOTER //
// ./app/util/s3/s3-upload.js